export default "__VITE_ASSET__eb51ab1f__"